import React from "react";

const ImageComponent = ({ src }) => (
  <div className="RowBox">
    <img src={src}></img>
  </div>
);

export default ImageComponent;
